import React from 'react';

/**
 * 右箭头图标（用于「查看更多」等）
 */
export const RightArrowIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 16 16"
    width="16"
    height="16"
    {...props}
  >
    <g>
      <path
        d="M5.8047380447387695,13.642303466796875C5.8047380447387695,13.642303466796875,7.138071444738769,13.642303466796875,7.138071444738769,13.642303466796875C7.138071444738769,13.642303466796875,7.138071444738769,20.308970466796875,7.138071444738769,20.308970466796875C7.138071444738769,20.308970466796875,13.80473804473877,20.308970466796875,13.80473804473877,20.308970466796875C13.80473804473877,20.308970466796875,13.80473804473877,21.642303466796875,13.80473804473877,21.642303466796875C13.80473804473877,21.642303466796875,6.471464754738769,21.642303466796875,6.471464754738769,21.642303466796875C6.47142475473877,21.642303466796875,6.471404734738769,21.642303466796875,6.471404734738769,20.975636966796877C6.471404734738769,20.975636966796877,6.471464754738769,21.642303466796875,6.471464754738769,21.642303466796875C6.471464754738769,21.642303466796875,5.80473844210212,21.642303466796875,5.80473844210212,21.642303466796875C5.80473844210212,21.642303466796875,5.8047380447387695,13.642303466796875,5.8047380447387695,13.642303466796875C5.8047380447387695,13.642303466796875,5.8047380447387695,13.642303466796875,5.8047380447387695,13.642303466796875Z"
        fillRule="evenodd"
        fill="currentColor"
        fillOpacity="0.9"
        transform="matrix(-0.7071068286895752,-0.7071067094802856,0.7071067094802856,-0.7071068286895752,0.26274364078949475,27.39343862543467)"
      />
    </g>
  </svg>
);
